import { motion, useMotionValue, useTransform } from 'framer-motion'
import { useRef } from 'react'

export default function Hulanim() {
  const ref = useRef<HTMLDivElement>(null)
  const x = useMotionValue(0)
  const y = useMotionValue(0)

  // Cursor-following glow
  const background = useTransform([x, y], ([latestX, latestY]) => {
    return `radial-gradient(200px at ${latestX}px ${latestY}px,
      rgba(255,184,110,0.4), rgba(111,71,255,0.0))`
  })

  return (
    <section className="relative flex flex-col items-center justify-center min-h-[90vh] overflow-hidden bg-[#0b0b0f] text-center text-white">
      
      {/* diagonal orange-purple light beam */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -left-1/3 top-1/3 w-[160%] h-[60%] rotate-[12deg]
                        bg-gradient-to-r from-[#ff8c42]/20 via-[#9c8eff]/15 to-transparent blur-[120px]" />
        <div className="absolute left-1/3 bottom-1/4 w-[140%] h-[40%] -rotate-[10deg]
                        bg-gradient-to-l from-[#6b5fff]/20 via-[#ff8c42]/15 to-transparent blur-[120px]" />
      </div>

      {/* rotating glowing clock */}
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 24, ease: 'linear' }}
        className="relative w-56 h-56 rounded-full border border-gray-800 flex items-center justify-center overflow-hidden shadow-[0_0_60px_rgba(255,255,255,0.05)]"
      >
        <motion.div
          animate={{ rotate: -360 }}
          transition={{ repeat: Infinity, duration: 12, ease: 'linear' }}
          className="absolute inset-0 bg-[conic-gradient(from_0deg,#ff8c42,#9c8eff,#6b5fff,#ff8c42)] opacity-40"
        />
        <div className="absolute inset-[22%] rounded-full bg-black flex items-center justify-center">
          <span className="text-4xl font-bold tracking-tight">H</span>
        </div>
      </motion.div>

      {/* text content */}
      <div className="mt-10 space-y-4">
        <h2 className="text-5xl font-bold">Join the Movement</h2>
        <p className="text-gray-400 max-w-md mx-auto">
          Unlock the future of productivity with Huly.<br />
          Remember, this journey is just getting started.
        </p>
      </div>

      {/* cursor-following button */}
      <motion.div
        ref={ref}
        onMouseMove={(e) => {
          const rect = ref.current?.getBoundingClientRect()
          if (!rect) return
          x.set(e.clientX - rect.left)
          y.set(e.clientY - rect.top)
        }}
        style={{ background }}
        className="relative mt-10 p-[2px] rounded-full"
      >
        <button className="bg-[#0b0b0f] rounded-full px-8 py-3 text-white font-semibold tracking-wide relative z-10">
          SEE IN ACTION
        </button>
        <div className="absolute inset-0 rounded-full blur-xl opacity-70" />
      </motion.div>

      {/* secondary button */}
      <button className="mt-5 bg-black border border-gray-800 rounded-full px-8 py-3 text-white flex items-center gap-2 hover:bg-gray-900 transition">
        <img src="/slack.svg" alt="Slack" className="w-5 h-5" />
        JOIN OUR SLACK
      </button>
    </section>
  )
}
